import React, { Fragment, PureComponent } from 'react'
import { map, isEqual } from 'lodash-es'
import NavBar from "./navigation/nav-bar"
import { Link } from "react-router-dom"
import { getThemeStyle, YOU_FILTER } from '../utilities/helpers'
import { formPagePath } from '../utilities/route'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import styled from 'styled-components'
import SortingWidget from './ui/sorting-widget'
import { TABLET, LAPTOP } from '../utilities/breakpoints'
import IconHidden from '../images/icon-hidden.svg'
import ParameterFilter from './ui/parameter-filter'
import Button from './ui/button'
import NavStatistics from './navigation/nav-statistics'
import StatisticsPageHero from './ui/statistics-page-hero'
import DriverStatBar from './ui/driver-stat-bar'
import DriverStat from './ui/driver-stat'
import RespondentGroups from './ui/respondent-groups'
import { sortingService } from '../utilities/sortingService'
import { Survey } from '../utilities/Survey'
import { mergeWithStatistics, likertResponseToPercentage } from '../utilities/statistics'

class StatisticsPageTheme extends PureComponent {
  t = (phrase) => {
    const { useTranslate } = this.props
    return useTranslate(`data_vault.${phrase}`)
  }

  handleFiltersChange = value => {
    this.props.onSetFilters(value);
  }

  getThemeId = () => {
    return this.props.match.params.catalystId
  };

  renderOpenQuestions = (questions) => {
    return (
      <div className="open-questions pb-4">
        {questions.map((question, index) =>
          <div className="open-question" key={index}>
            <div className="open-question-header">
              <div className="mr-3 open-question-icon">?</div>
              <h6>{question.title}</h6>
              {question.respondentGroups && <RespondentGroups items={question.respondentGroups} useTranslate={this.props.useTranslate} />}
            </div>
            <div className="open-question-body">
              {question.answers.map((answer, index) =>
                <div key={index} className={`open-question-answer ${answer.public ? '':'private'}`}>
                  {answer.answer}
                  {!answer.public &&
                    <div className="private-indicator"><img src={IconHidden} alt="Hidden icon"/>{this.t("hidden_from_public")}</div>
                  }
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderAnsweredOpenQuestions(questions) {
    const answered = questions.filter(q => q.answers.length > 0)
    return answered.length > 0
      ? this.renderOpenQuestions(answered)
      : <p>{this.t("no_public_answers")}</p>
  }

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      surveyStatistics,
      afterGameDetailedOpenQuestionsStatistics,
      respondentParameters,
      questionnaire,
      questionnaire: {
        logo,
        isDialogueActive,
        areProgressReportsActive,
        canViewAfterGame,
        canAnswer,
        isAfterGameGuest,
        isFinished,
      },
      useTranslate,
      sortingType,
      sortAscending,
      filters,
      improvementProject
    } = this.props;

    const to = formPagePath(languageCode, surveyId, 'finish');
    const toStatistics = formPagePath(languageCode, surveyId, 'finish', 'themes');
    const toEditAnswers = formPagePath(languageCode, surveyId)

    const title = (!canViewAfterGame && !isAfterGameGuest)
      ? useTranslate("survey_finished.your_statistics_page_title")
      : useTranslate("data_vault.statistics_page_title");

    const startEditingSurvey = () => {
      sessionStorage.setItem("surveyBeingEdited", "true");
      this.setState({surveyBeingEdited: true});
    }

    const isAfterGame = (canViewAfterGame || isAfterGameGuest)
    const survey = new Survey(questionnaire.catalysts, respondentParameters)
    const sortingFunction = sortingService.getSortingFunction(sortingType);
    let theme
    let sortedDrivers
    const notEnoughRespondents = surveyStatistics.__typename === 'NotEnoughRespondentsError'
    if (!notEnoughRespondents) {
      theme = mergeWithStatistics(survey.getThemes(), surveyStatistics.themes).find(t => t.id === this.getThemeId())
      theme.result = likertResponseToPercentage(theme.statistics.aggregatedResponse)
      theme.openQuestions = afterGameDetailedOpenQuestionsStatistics.map(q => ({
        title: survey.getOpenQuestion(q.id).title,
        answers: q.answers,
        respondentGroups: isAfterGame ? survey.getRespondentGroups(q.id, 'open') : undefined
      }))
      theme.surveyThemeIndex = survey.getSurveyThemeIndex(this.getThemeId())
      sortedDrivers = mergeWithStatistics(survey.getDrivers(), surveyStatistics.drivers)
        .filter(driver => survey.getThemeIdByDriverId(driver.id) === this.getThemeId())
        .map(driver => {
          return {
            title: driver.title,
            description: driver.description,
            result: likertResponseToPercentage(driver.statistics.aggregatedResponse),
            rate: driver.statistics.aggregatedImportance,
            questions: mergeWithStatistics(survey.getLikertQuestions(), surveyStatistics.questions)
              .filter(question => driver.affectingQuestionIds.includes(question.id))
              .map(question => ({
                id: question.id,
                title: question.title,
                result: likertResponseToPercentage(question.statistics.aggregatedResponse),
                rate: question.statistics.aggregatedImportance,
                skipped: question.statistics.skippedRespondentCount,
                participants: question.statistics.totalRespondentCount,
                respondentGroups: isAfterGame ? survey.getRespondentGroups(question.id, 'likert') : undefined
              }))
          }
        }).sort(sortingFunction(sortAscending ? sortAscending : false));
    } else {
      theme = survey.getThemes().find(t => t.id === this.getThemeId())
    }

    const showDistribution = (canViewAfterGame || isAfterGameGuest) && !isEqual(filters, YOU_FILTER);

    return (
      <section className="finish-page">
        <StatisticsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && toStatistics}
              inverse={true}
              afterGame
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"statistics"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{title}</h1>
              { (!canViewAfterGame && !isAfterGameGuest) ?
                <div className="stats-description">
                  <p>{useTranslate("survey_finished.your_statistics_page_description")}</p>
                  { (isFinished && !canViewAfterGame && canAnswer) &&
                    <div>
                      <Button
                        as={Link}
                        to={toEditAnswers}
                        onClick={() => startEditingSurvey()}
                        size={"md"}
                      >
                        {this.t("edit_answers_button")}
                      </Button>
                    </div>
                  }
                </div>
                :
                <div className="stats-description">
                  <p>{useTranslate("data_vault.statistics_page_description")}</p>
                </div>
              }
              <div className="finish-page__intro__nav-holder">
                <NavStatistics
                  activePage={"themes"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </StatisticsPageHero>
        <div className="aftergame-page-container statistics-page-content finish-page__stats pb-5">
          <div className="finish-page__filters">
            {(canViewAfterGame || isAfterGameGuest) &&
              <ParameterFilter
                filters={filters}
                handleFiltersChange={this.handleFiltersChange}
                respondentParameters={respondentParameters}
                isAfterGameGuest={isAfterGameGuest}
                useTranslate={useTranslate}
              />
            }
            <SortingWidget useTranslate={useTranslate} />
          </div>

          <ThemeResultCard>
            <Header style={{ backgroundColor: getThemeStyle(survey.getSurveyThemeIndex(theme.id)).bgColor }}>
              <HeroImage>
                <img src={getThemeStyle(survey.getSurveyThemeIndex(theme.id)).bgImage} alt="Shapes"/>
              </HeroImage>
              <AllThemesButton
                as={Link}
                to={`${to}/themes`}
                size={"sm"}
                kind={"link"}
              >
                <svg width="8" height="13" viewBox="0 0 8 13" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 11.4725L3.05533 6.5L8 1.5275L6.47773 0L0 6.5L6.47773 13L8 11.4725Z" />
                </svg>
                {useTranslate("data_vault.all_themes_button")}
              </AllThemesButton>
              <h2>{theme.title}</h2>
              {theme.description &&
                <p>{theme.description}</p>
              }
            </Header>
            <ResultContainer>
              {!notEnoughRespondents ?
                <Fragment>
                  <h5>{useTranslate("data_vault.theme_result")}</h5>
                  <DriverStatBar
                    result={theme.result}
                    useTranslate={useTranslate}
                    barColor={getThemeStyle(survey.getSurveyThemeIndex(theme.id)).bgColor}
                    size="lg"
                  />
                </Fragment>
                :
                <p style={{margin: "0", color: "#666"}}>{useTranslate("data_vault.no_results_for_parameter")}</p>
              }
            </ResultContainer>
          </ThemeResultCard>

          {!notEnoughRespondents &&
            <Fragment>
              <div className="mb-5">
                <SectionTitle>{useTranslate("data_vault.drivers")}</SectionTitle>
                {sortedDrivers.length > 0 &&
                  map(sortedDrivers, (driver, index) => (
                    <div
                      key={index}
                      className="bg-white finish-page__stats--details finish-page__stats--details--with-padding bs mb-3"
                    >
                      <div className="w-100">
                        <DriverStat
                          index={index}
                          driverStats={{ "result": driver.result, "rate": driver.rate }}
                          driverTitle={driver.title}
                          driverDescription={driver.description}
                          theme={theme}
                          questions={driver.questions}
                          useTranslate={useTranslate}
                          surveyId={surveyId}
                          questionnaire={this.props.questionnaire}
                          sortBy={sortingFunction}
                          ascending={sortAscending}
                          filters={filters}
                          showThemeBadge={false}
                          showDistribution={showDistribution}
                        />
                      </div>
                    </div>
                  ))
                }
              </div>
              {theme.openQuestions && theme.openQuestions.length > 0 && (
                <div className="mb-5">
                  <SectionTitle>{useTranslate("data_vault.open_answers")}</SectionTitle>
                  {this.renderAnsweredOpenQuestions(theme.openQuestions)}
                </div>
              )}
            </Fragment>
          }
        </div>
      </section>
    );
  }
}

export default StatisticsPageTheme;

const AllThemesButton = styled(Button)`
  position: relative;
  color: #fff;
  font-weight: 500;
  font-size: 15px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 3.5rem;
  transition: all .2s ease-in-out;
  
  svg {
    margin-right: .5rem;
    margin-top: -2px;
  }
  
  &:hover,
  &:focus {
    text-decoration: none;
    opacity: 0.8;
    color: #fff;
    
    svg {
      fill: #fff;
    }
  }
`;

const Header = styled.div`
  position: relative;
  border-radius: 10px 10px 0 0;
  padding: 20px 15px;
  color: #fff;
  gap: 20px;
  overflow: hidden;
  
  h2, p {
    max-width: 600px;
  }
  
  h2 {
    margin-bottom: 1.5rem;
  }
  
  p {
    margin-bottom: 0;
  }
  
  @media${TABLET} {
    padding: 30px 20px;
    gap: 20px;
    
    h2, p {
      max-width: 65%;
    }
  }
  
  @media${LAPTOP} {
    padding: 40px 40px 50px;
  }
`;

const ResultContainer = styled.div`
  padding: 30px 15px;
  
  @media${TABLET} {
    padding: 30px 20px;
  }
  
  @media${LAPTOP} {
    padding: 40px 40px;
  }
`;

const ThemeResultCard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.06);
  margin-bottom: 3rem;
`;

const HeroImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  display: none;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: 768px) {
    display: flex;
    
    img {
      width: 30%;
    }
  }
  @media (min-width: 1200px) {
     img {
       width: 38%;
       margin-right: -5%;
    } 
  }
`;

const SectionTitle = styled.h5`
  margin-bottom: 1rem;
`;


// WEBPACK FOOTER //
// ./src/components/statistics-page-theme.js